import { State as S, Trigger as T, Product as P } from "./IDs.js";
import { TYPE_DAILY, TYPE_MONTHLY } from "./ComparableProducts";
export const STATECHART_ID = "wizard";
const Statechart = {
  // ID of the state machine
  id: STATECHART_ID,
  initial: S.START,
  // All the states this has
  states: {
    //
    // Level 0
    //
    [S.START]: {
      on: {
        [T.NEUTRAEGER]: S.L1_2,
        [T.ERSTTRAEGER]: S.L1_1,
      },
    },
    //
    // Level 1
    //
    [S.L1_1]: {
      on: {
        [T.JA]: S.L2_1,
        [T.NEIN]: P.Sehtest_oder_Anpassung,
      },
    },
    [S.L1_2]: {
      on: {
        [T.JA]: S.L2_2,
        [T.NEIN]: S.L2_1,
      },
    },
    //
    // Level 2
    //
    [S.L2_1]: {
      on: {
        [T.KURZ_ODER_WEIT]: S.L3_1,
        [T.HORNHAUT]: S.L3_2,
        [T.ALTERSSICHTIGKEIT]: P.Premium_Monthly_Multifocal,
      },
    },
    [S.L2_2]: {
      on: {
        [T.TAGESLINSEN]: S.L2_3,
        [T.MONATSLINSEN]: S.L2_4,
      },
    },
    [S.L2_3]: {
      on: {
        [P.Premium_Daily_Spheric]: P.Premium_Daily_Spheric,
        [P.Platinum_Daily_Toric]: P.Platinum_Daily_Toric,
        [P.Platinum_Daily_Spheric]: P.Platinum_Daily_Spheric,
        [P.Comfort_Daily_Spheric]: P.Comfort_Daily_Spheric,
        [P.Comfort_Monthly_Spheric]: P.Comfort_Monthly_Spheric,
        [P.Premium_Monthly_Multifocal]: P.Premium_Monthly_Multifocal,
        [P.Premium_Monthly_Spheric]: P.Premium_Monthly_Spheric,
        [P.Premium_Monthly_Toric]: P.Premium_Monthly_Toric,
        [T.LINSE_NICHT_ENTHALTEN]: S.L2_1,
      },
      data: {
        hideTriggers: [
          P.Premium_Daily_Spheric,
          P.Platinum_Daily_Toric,
          P.Platinum_Daily_Spheric,
          P.Comfort_Daily_Spheric,
          P.Comfort_Monthly_Spheric,
          P.Premium_Monthly_Multifocal,
          P.Premium_Monthly_Spheric,
          P.Premium_Monthly_Toric,
        ],
        showComparableProducts: TYPE_DAILY,
      },
    },
    [S.L2_4]: {
      on: {
        [P.Premium_Daily_Spheric]: P.Premium_Daily_Spheric,
        [P.Platinum_Daily_Toric]: P.Platinum_Daily_Toric,
        [P.Platinum_Daily_Spheric]: P.Platinum_Daily_Spheric,
        [P.Comfort_Daily_Spheric]: P.Comfort_Daily_Spheric,
        [P.Comfort_Monthly_Spheric]: P.Comfort_Monthly_Spheric,
        [P.Premium_Monthly_Multifocal]: P.Premium_Monthly_Multifocal,
        [P.Premium_Monthly_Spheric]: P.Premium_Monthly_Spheric,
        [P.Premium_Monthly_Toric]: P.Premium_Monthly_Toric,
        [T.LINSE_NICHT_ENTHALTEN]: S.L2_1,
      },
      data: {
        hideTriggers: [
          P.Premium_Daily_Spheric,
          P.Platinum_Daily_Toric,
          P.Platinum_Daily_Spheric,
          P.Comfort_Daily_Spheric,
          P.Comfort_Monthly_Spheric,
          P.Premium_Monthly_Multifocal,
          P.Premium_Monthly_Spheric,
          P.Premium_Monthly_Toric,
        ],
        showComparableProducts: TYPE_MONTHLY,
      },
    },
    //
    // Level 3
    //
    [S.L3_1]: {
      on: {
        [T.DAUERND]: S.L4_1,
        [T.GELEGENTLICH]: S.L4_2,
      },
    },
    [S.L3_2]: {
      on: {
        [T.DAUERND]: P.Premium_Monthly_Toric,
        [T.GELEGENTLICH]: P.Platinum_Daily_Toric,
      },
    },
    //
    // Level 4
    //
    [S.L4_1]: {
      on: {
        [T.JA]: P.Premium_Monthly_Spheric,
        [T.NEIN]: P.Comfort_Monthly_Spheric,
      },
    },
    [S.L4_2]: {
      on: {
        [T.JA]: S.L5_1,
        [T.NEIN]: P.Comfort_Daily_Spheric,
      },
    },
    //
    // Level 5
    //
    [S.L5_1]: {
      on: {
        [T.JA]: P.Platinum_Daily_Spheric,
        [T.NEIN]: P.Premium_Daily_Spheric,
      },
    },
    //
    // Results
    //
    [P.Comfort_Daily_Spheric]: {},
    [P.Comfort_Monthly_Spheric]: {},
    // Premium...
    [P.Premium_Daily_Spheric]: {},
    [P.Premium_Monthly_Multifocal]: {},
    [P.Premium_Monthly_Spheric]: {},
    [P.Premium_Monthly_Toric]: {},
    // Platinum...
    [P.Platinum_Daily_Toric]: {},
    [P.Platinum_Daily_Spheric]: {},
    // Sehtest...
    [P.Sehtest_oder_Anpassung]: {},
  },
};
export default Statechart;

export const Helper = {
  getAvailableTriggers: (state, showAll) => {
    const _state = Statechart.states[state.value];
    const data = _state.data;
    let triggers = _state.on ? Object.keys(_state.on) : [];
    if (!showAll && data && data.hasOwnProperty("hideTriggers")) {
      if (data.hideTriggers === true) {
        triggers = [];
      } else if (data.hideTriggers.constructor === Array) {
        triggers = triggers.filter(
          trigger => data.hideTriggers.indexOf(trigger) < 0
        );
      }
    }
    return triggers;
  },
  getData: state => {
    const data = Statechart.states[state.value].data;
    return data ? data : {};
  },
};



// WEBPACK FOOTER //
// ./src/Wizard/Statechart.js